import React, {useState} from "react";

const HowToBuy = () => {
  const SingleInfo = ({ title, des, className }) => (
    <div
      className={`flex items-start gap-[20px] max-w-[412px] w-full ${className}`}
    >
      <div className="min-w-[60px] min-h-[60px] rounded-[16px] bg-[#09090A]"></div>
      <div>
        <h2 className="text-res-normal leading-[30px] font-bold mb-[10px]">
          {title}
        </h2>
        <p className="text-res-xxs leading-[22px] font-bold">{des}</p>
      </div>
    </div>
  );
  return (
    <div className="mt-[253px]">
      <h2 className="text-res-lg font-bold text-center mb-[50px]">
        How to buy the NFTs
      </h2>
      <div className="bg-main-black pb-4">
        <div className="max-w-[1410px] px-4 xl:px-4 2xl:px-0 mx-auto pt-[87px]">
          <div className="flex flex-col xl:flex-row gap-[20px] 2xl:gap-[74px] justify-center items-center">
            <div className="w-full max-w-[416px]">
              <h2 className="text-normal mb-[10px] font-bold md:text-[36px] md:leading-[44px]">
                Step 1: Create a Wallet
              </h2>
              <p className="mt-[14px]">
                To securely store and interact with NFTs, you'll need a
                compatible cryptocurrency wallet. Popular options include
                MetaMask, Trust Wallet, or Coinbase Wallet. Set up your
                preferred wallet and ensure that you have some Ethereum (ETH) or
                the specified token required for the NFT purchase.
              </p>
            </div>

            <div className="grow flex gap-x-[48px]   flex-wrap">
              <SingleInfo
                title={"Step 2: Find a Marketplace"}
                des={
                  "Once you have your cryptocurrency wallet ready, the next step is to find a marketplace where you can browse and purchase NFTs. Some popular NFT marketplaces include OpenSea, Rarible, SuperRare, and NBA Top Shot. Explore these platforms and choose one that suits your interests and desired NFT collection."
                }
              ></SingleInfo>
              <SingleInfo
                title={"Step 3: Browse and Discover NFTs"}
                des={
                  "Once you have chosen a marketplace, start browsing and exploring the available NFTs. Most marketplaces provide search and filtering options to help you find NFTs based on different criteria such as artist, category, price, or popularity. Take your time to discover different collections and artworks until you find something you like."
                }
              ></SingleInfo>
              <SingleInfo
                title={"Step 4: Connect your Wallet"}
                className="mt-[32px]"
                des={
                  "Before you can make a purchase, you need to connect your cryptocurrency wallet to the NFT marketplace. Typically, there will be a 'Connect Wallet' or similar button on the marketplace's website. Click on it and follow the instructions to connect your wallet. This step is necessary to link your wallet's address with the marketplace and enable transactions."
                }
              ></SingleInfo>
              <SingleInfo
                title={"Step 5: Place a Bid or Make a Purchase"}
                className="mt-[29px]"
                des={
                  "Once your wallet is connected, you can start placing bids or making purchases on the desired NFTs. For auctions or items with a listed price, you can directly purchase them by clicking the 'Buy' or 'Purchase' button and confirming the transaction through your wallet. In the case of auctions, you may need to place a bid and wait for the auction to end before knowing if you've won."
                }
              ></SingleInfo>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowToBuy;
